import { render, staticRenderFns } from "./AccessoryItemsListCard.vue?vue&type=template&id=32c99774&scoped=true&"
import script from "./AccessoryItemsListCard.vue?vue&type=script&lang=ts&"
export * from "./AccessoryItemsListCard.vue?vue&type=script&lang=ts&"
import style0 from "./AccessoryItemsListCard.vue?vue&type=style&index=0&id=32c99774&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c99774",
  null
  
)

export default component.exports